import Head from "next/head";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import styles from "../styles/components/Home.module.scss";
import React from "react";
import useTranslation from "next-translate/useTranslation";
const Footer = dynamic(() => import("../components/Footer"));
const Header = dynamic(() => import("../components/Header"));
const Heading = dynamic(() => import("../components/Heading"));
const Hero = dynamic(() => import("../components/Hero"));
const EmployeeCard = dynamic(() => import("../components/EmployeeCard"));

function Directors({
  authKeys,
  subscriptions,
  subscriptionInfo,
  userDetails,
  signupBook,
  fullUrl,
  origin,
  investorsDirectors,
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const { locale } = router;
  const url = `${origin}${fullUrl}`;
  const tempCode = locale.substring(0, 2).toUpperCase();
  const defaultImage = `${origin}/cdn/images/nextory-share-pink.jpg`;
  const isLoggedIn = userDetails.isLoggedIn;

  const menu = !isLoggedIn ? "noBg" : "registeredUser";
  const { Title, SideTitle, Peoples, Image } = investorsDirectors;

  return (
    <>
      <Head>
        <title>{t("lang_common:seo.title")}</title>
        <link rel="alternate" href={`${origin}`} hrefLang={tempCode} />
        <meta httpEquiv="Content-Language" content={locale} />
        <meta name="name" content={t(`lang_seo:generic.title`)} />
        <meta name="description" content={t("lang_common:seo.description")} />
        <meta name="image" content={defaultImage} />
        <meta
          name="og:description"
          content={t(`lang_seo:generic.ogDescription`)}
        />
        <meta name="og:title" content={t("lang_seo:generic.ogTitle")} />
        <meta name="og:site_name" content={t("lang_seo:generic.ogSiteName")} />
        <meta name="og:image" content={defaultImage} />
        <meta name="og:url" content={url} />
        <meta name="fb:app_id" content={`${process.env.FB_ID}`} />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-medium.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-regular.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/headline/nextorysans-headline-demibold.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link rel="canonical" href={url} data-react-helmet="true"></link>
      </Head>
      <div id="newUI" className={styles.app}>
        <main className={styles.main}>
          <Header
            authKeys={authKeys}
            subscriptions={subscriptions}
            subscriptionInfo={subscriptionInfo}
            userDetails={userDetails}
            signupBook={signupBook}
            noBackground={menu}
            searchIcon={"dark"}
            modifiers={"investors"}
          />

          {/* Board of Directors   */}
          <Heading header={Title || ""} />
          <Hero label={SideTitle || ""} image={Image?.url} />
          {Peoples &&
            Peoples.map((director) => {
              return (
                <EmployeeCard spaceTop spaceBottom employeeDetails={director} />
              );
            })}

          <Footer spaceTop userDetails={userDetails} />
        </main>
      </div>
    </>
  );
}

export default Directors;
